

























// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule, snackModule, bookingModule } from '@/store';
import { ApiError, User } from '@/api';

@Component
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;
  error: string = '';
  success: string = '';
  showForm: boolean = true;

  user = {
    email: '',
    password: '',
    title: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    business: '',
  };

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  passwordRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Password required',
    (v: string) =>
      v8n()
        .string()
        .minLength(8)
        .test(v) || 'Password must be at least 8 chars',
    (v: string) =>
      v8n()
        .not.numeric()
        .minLength(8)
        .test(v) || 'Password must include non-numeric chars',
  ];

  get titles() {
    if (!bookingModule.titles) {
      return;
    }
    return bookingModule.titles;
  }

  clear() {
    this.user = {
      email: '',
      password: '',
      title: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      business: '',
    };

    // @ts-ignore
    this.$refs.registerForm.resetValidation();
  }

  async register() {
    this.loading = true;
    try {
      await User.register(this.user);
      snackModule.showSnackbar('Registration Successful');
      this.error = '';
      this.success =
        'Registration success!<br>An email has been sent to your email address to verify your account.';
      this.showForm = false;
    } catch (e) {
      this.error = e.response ? e.response.errors[0].detail : 'Unknown error';
    } finally {
      this.loading = false;
      try {
        await authModule.login({
          email: this.user.email,
          password: this.user.password,
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
